export default __webpack_public_path__ + "static/media/Auto-Skip-690x460.eeda5a62.png";